<p-dialog
  [dismissableMask]="false"
  [showHeader]="true"
  (onHide)="closeDialog()"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{'width':'520px'}"
>


  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-print mg-r-5"></i> Impression des effectifs
    </div>
  </ng-template>

  <!--  CONTENT-->
  <ng-container>

    <div class="d-flex">
      <div class="width-100">Mode</div>
      <p-multiSelect [options]="modeOptionsList"
                     [(ngModel)]="selectedMode"
                     showToggleAll="true"
                     defaultLabel="Selection..."
                     optionLabel="label"
                     [style]="{'width':'400px'}"
                     appendTo="body"></p-multiSelect>
    </div>

    <div class="d-flex mg-t-20">
      <div class="width-100">Repas</div>
      <p-multiSelect [options]="repasList"
                     [(ngModel)]="selectedRepasList"
                     [filter]="true"
                     showToggleAll="true"
                     filterBy="libelle"
                     optionLabel="libelle"
                     [style]="{'width':'400px'}"
      >
      </p-multiSelect>
    </div>

    <div class="d-flex mg-t-20">
      <div class="width-100">Régimes</div>
      <p-multiSelect [options]="modeRegimesList"
                     [(ngModel)]="selectedRegimes"
                     showToggleAll="true"
                     defaultLabel="Selection..."
                     optionLabel="label"
                     appendTo="body"
                     [style]="{'width':'400px'}"
      ></p-multiSelect>
    </div>

  </ng-container>

  <ng-template pTemplate="footer">
    <span class="mg-r-5">
      <button type="button" pButton
              [disabled]="isPrintDisabled()"
              icon="fas fa-print"
              (click)="printEffectif()"
              pTooltip="Imprimer les effectifs"
              label="Imprimer"
              showDelay="500"
      ></button>
    </span>
    <span class="mg-r-5">
      <button type="button" class="p-button-secondary" pButton icon="fas fa-times" (click)="closeDialog()"
              class="p-button-secondary"
              pTooltip="Annuler" label="Annuler"
              showDelay="500"></button>
    </span>


  </ng-template>


</p-dialog>
